import { useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { useAirline } from '../contexts/AirlineContext';

export interface FleetModel {
  id: string;
  code: string;
  name: string;
  classification?: string;
}

type FleetModelRow = {
  fleet_models: {
    id: string;
    code: string;
    name: string;
    classification: string | null;
  };
};

export function useFleetModels() {
  const { selectedAirline } = useAirline();

  const searchFleetModels = useCallback(
    async (query: string): Promise<FleetModel[]> => {
      if (!selectedAirline?.airline_id) return [];

      let dbQuery = supabase
        .from('airline_fleets')
        .select('fleet_models!inner(id, code, name, classification)')
        .eq('airline_id', selectedAirline.airline_id);

      if (query.trim()) {
        dbQuery = dbQuery.ilike('fleet_models.name', `%${query.trim()}%`);
      }

      const { data, error } = await dbQuery;
      if (error) throw error;

      const rows = (data ?? []) as unknown as FleetModelRow[];
      return rows.map((row) => ({
        id: row.fleet_models.id,
        code: row.fleet_models.code,
        name: row.fleet_models.name,
        classification: row.fleet_models.classification ?? undefined,
      }));
    },
    [selectedAirline?.airline_id],
  );

  return { searchFleetModels };
}
